<script setup name="CookiePolicyParagraph">
import CookiePolicyCollapsible from '~/components/CookiePolicyCollapsible.vue';
import CookiePolicyTitle from '~/components/CookiePolicyTitle.vue';

defineProps({
  title: {
    type: String,
    default: null,
  },
  counted: {
    type: Array,
    default: null,
  },
  collapsibles: {
    type: Array,
    default: null,
  },
});
</script>

<template>
  <div class="space-y-4">
    <slot name="title">
      <CookiePolicyTitle>{{ title }}</CookiePolicyTitle>
    </slot>
    <p class="leading-8">
      <slot />
    </p>
    <template v-if="counted">
      <ol
        v-for="(item, i) in counted"
        :key="i"
        class="ml-4 list-disc space-y-4"
      >
        <li class="text-ocean-5">
          <span class="relative -right-2 text-black">{{
            item.description
          }}</span>
        </li>
      </ol>
    </template>
    <template v-if="collapsibles">
      <div class="mt-4 divide-y divide-charcoal-2">
        <div v-for="collapsible in collapsibles" :key="collapsible.title">
          <CookiePolicyCollapsible v-bind="collapsible" />
        </div>
      </div>
    </template>
    <slot name="append" />
  </div>
</template>
